module.exports = __webpack_public_path__ + "static/media/ic_activity_log.77b76825.svg";